import { I18n } from '@lingui/core'
import { Tab, Tabs } from '@vgw/multibrand-fe-tabs'
import { msg } from '@lingui/core/macro'
import { useMemo } from 'react'
import { useLingui } from '@lingui/react/macro'
import {
  activityLogSearchSchema,
  ActivityLogTabValue,
  useActivityLogTabs,
} from '@/features/activity-log/use-activity-log-tabs'
import { ActivityLogContent } from '@/features/activity-log/activity-log-content'
import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { assertCanPlayBeforeLoad } from '@/features/ctrls-and-caps/assert-can-play-before-load'
import { TertiaryPageLayout } from '@/routes/-tertiary-page-layout'

const getTabs = (i18n: I18n): Tab[] => [
  {
    label: i18n._(msg`Gold Coins`),
    value: 'gold-coins',
  },
  {
    label: i18n._(msg`Sweeps Coins`),
    value: 'sweep-coins',
  },
]

export const Route = createFileRoute('/_app/activity-log')({
  component: ActivityLog,
  validateSearch: zodValidator(activityLogSearchSchema),
  beforeLoad: async ({ context }) => {
    return assertCanPlayBeforeLoad(context.queryClient)
  },
})

function ActivityLog() {
  const { currentTab, setCurrentTab } = useActivityLogTabs()
  const { i18n, t } = useLingui()
  const tabs = useMemo(() => getTabs(i18n), [i18n])

  return (
    <TertiaryPageLayout
      headerText={t`Activity Log`}
      subheader={
        <Tabs
          containerClassName="mx-4 md:mx-auto md:w-md"
          items={tabs}
          defaultValue={currentTab!}
          value={currentTab}
          onValueChange={(value) => setCurrentTab(value as ActivityLogTabValue)}
          hideContent
        />
      }
    >
      <ActivityLogContent currentTab={currentTab} />
    </TertiaryPageLayout>
  )
}
